export const NAME = 'audit';

// Mirrors backend AuditLogActionEnum (Replyco.Core/Enums/AuditLogActionEnum.cs).
export const AUDIT_ACTIONS = {
    ADMIN_LOGIN: 1,
    IMPERSONATE_USER: 2,
    COMPANY_DETAILS_UPDATE: 3,
    COMPANY_FEATURES_UPDATE: 4,
    USER_UPDATE: 5,
    USER_UNBLOCK: 6,
    USER_DISABLE_2FA: 7,
    USER_REVOKE_SESSIONS: 8,
    USER_UNLINK_COMRCE: 9,
    INTEGRATION_BLOCK: 10,
    INTEGRATION_UNBLOCK: 11,
    INTEGRATION_SET_NEED_RELOGIN: 12,
    SUBSCRIPTION_SETUP_MANUAL: 13,
    SUBSCRIPTION_REMOVE: 14,
    SUBSCRIPTION_CANCEL_MANUAL: 15,
    COMPANY_DELETE: 16,
    COMPANY_CUSTOMIZE_UI: 17,
    COMPANY_SETUP_SETTINGS_APPLY: 18,
    INTEGRATION_UPDATE: 19,
    INTEGRATION_BLOCK_MARKET_SYNC: 20,
    INTEGRATION_UNBLOCK_MARKET_SYNC: 21,
    INTEGRATION_TOGGLE_EXCEEDED_LIMIT_BLOCK: 22,
    INTEGRATION_SET_PRIORITY_SYNC: 23,
    INTEGRATION_MIGRATE: 24,
    THREAD_RESTORE: 25,
    THREADS_IMPORT: 26,
    NOTIFICATION_CREATE: 27,
    ADMIN_SETTINGS_UPDATE: 28,
    USER_RESET_NPS_REVIEW_DATE: 29,
    REGISTRATIONS_REMOVE: 30,
    CUSTOMER_DATA_ENCRYPT: 31,
    EMAIL_ACCOUNT_CREATE: 32,
    SYNC_JOB_REMOVE: 33,
    DATA_REMOVAL_JOB_RUN: 34
};

export const AUDIT_ACTION_LABELS = {
    [AUDIT_ACTIONS.ADMIN_LOGIN]: 'Admin login',
    [AUDIT_ACTIONS.IMPERSONATE_USER]: 'Impersonate user',
    [AUDIT_ACTIONS.COMPANY_DETAILS_UPDATE]: 'Company details update',
    [AUDIT_ACTIONS.COMPANY_FEATURES_UPDATE]: 'Company features update',
    [AUDIT_ACTIONS.USER_UPDATE]: 'User update',
    [AUDIT_ACTIONS.USER_UNBLOCK]: 'Unblock user',
    [AUDIT_ACTIONS.USER_DISABLE_2FA]: 'Disable 2FA',
    [AUDIT_ACTIONS.USER_REVOKE_SESSIONS]: 'Revoke sessions',
    [AUDIT_ACTIONS.USER_UNLINK_COMRCE]: 'Unlink Comrce',
    [AUDIT_ACTIONS.INTEGRATION_BLOCK]: 'Block integration',
    [AUDIT_ACTIONS.INTEGRATION_UNBLOCK]: 'Unblock integration',
    [AUDIT_ACTIONS.INTEGRATION_SET_NEED_RELOGIN]: 'Set need relogin',
    [AUDIT_ACTIONS.SUBSCRIPTION_SETUP_MANUAL]: 'Set up manual subscription',
    [AUDIT_ACTIONS.SUBSCRIPTION_REMOVE]: 'Remove subscription',
    [AUDIT_ACTIONS.SUBSCRIPTION_CANCEL_MANUAL]: 'Cancel manual subscription',
    [AUDIT_ACTIONS.COMPANY_DELETE]: 'Delete company',
    [AUDIT_ACTIONS.COMPANY_CUSTOMIZE_UI]: 'Customize company UI',
    [AUDIT_ACTIONS.COMPANY_SETUP_SETTINGS_APPLY]: 'Apply setup settings',
    [AUDIT_ACTIONS.INTEGRATION_UPDATE]: 'Update integration',
    [AUDIT_ACTIONS.INTEGRATION_BLOCK_MARKET_SYNC]: 'Block market sync',
    [AUDIT_ACTIONS.INTEGRATION_UNBLOCK_MARKET_SYNC]: 'Unblock market sync',
    [AUDIT_ACTIONS.INTEGRATION_TOGGLE_EXCEEDED_LIMIT_BLOCK]: 'Toggle exceeded-limit block',
    [AUDIT_ACTIONS.INTEGRATION_SET_PRIORITY_SYNC]: 'Set priority sync',
    [AUDIT_ACTIONS.INTEGRATION_MIGRATE]: 'Migrate integration',
    [AUDIT_ACTIONS.THREAD_RESTORE]: 'Restore thread',
    [AUDIT_ACTIONS.THREADS_IMPORT]: 'Import threads',
    [AUDIT_ACTIONS.NOTIFICATION_CREATE]: 'Send notification',
    [AUDIT_ACTIONS.ADMIN_SETTINGS_UPDATE]: 'Admin settings update',
    [AUDIT_ACTIONS.USER_RESET_NPS_REVIEW_DATE]: 'Reset NPS review date',
    [AUDIT_ACTIONS.REGISTRATIONS_REMOVE]: 'Remove registrations',
    [AUDIT_ACTIONS.CUSTOMER_DATA_ENCRYPT]: 'Encrypt customer data',
    [AUDIT_ACTIONS.EMAIL_ACCOUNT_CREATE]: 'Create email account',
    [AUDIT_ACTIONS.SYNC_JOB_REMOVE]: 'Remove sync job',
    [AUDIT_ACTIONS.DATA_REMOVAL_JOB_RUN]: 'Run data removal job'
};

export const AUDIT_ACTION_OPTIONS = Object.keys(AUDIT_ACTION_LABELS).map(value => ({
    value: Number(value),
    label: AUDIT_ACTION_LABELS[value]
}));
